import React, { useEffect, useState } from 'react';
import { IListItem } from '../_Core/CoreTypes';
import Button from '../_Core/Button';
import { sanitizeHtml } from '../../utils/Tools';

interface IProps {
  participants: IListItem[];
  selectedParticipant: number[];
  updateSelected: (selected: number[]) => void;
  Back: () => void;
}

const ParticipantList = (props: IProps) => {
  const [selectedParticipants, setSelectedParticipants] = useState<Record<number, boolean>>({});

  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filteredParticipants, setFilteredParticipants] = useState<IListItem[]>(props.participants);
  
  useEffect(() => {
    const initialSelected: Record<number, boolean> = {};
    props.selectedParticipant.forEach((id) => {
      initialSelected[id] = true;
    });
    setSelectedParticipants(initialSelected);
    //only run this the first time
  }, []);

  useEffect(() => {
    setFilteredParticipants(
      props.participants.filter((participant) =>
        participant.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, props.participants]);

  const handleSaveAndNext = () => {
    let selected: number[] = [];
    for (const id in selectedParticipants) {
      if (selectedParticipants[id]) {
        selected.push(Number(id));
      }
    }
    props.updateSelected(selected);
  };

  const handleSelectAll = () => {
    //only apply to filtered list
    const allSelected: Record<number, boolean> = {};
    filteredParticipants.forEach((participant) => {
      allSelected[participant.id] = true;
    });
    setSelectedParticipants(allSelected);
  };

  const handleDeselectAll = () => {
    //only apply to filtered list
    const newSelected: Record<number, boolean> = { ...selectedParticipants };
    filteredParticipants.forEach((participant) => {
      newSelected[participant.id] = false;
    });
    setSelectedParticipants(newSelected);
  };

  return (
    <div>
      <p>Select the participants you want to promote. You can use the buttons below to quickly select or deselect all participants.</p>
      <div className="form-group">
        <div className='col-sm-4'>
          <div className="btn-group btn-xs">
            <Button text="Select All" onClick={handleSelectAll} />
            <Button text="Deselect All" onClick={handleDeselectAll} />
            </div>
        </div>
        <div className="col-sm-3">
            Total Selected: {Object.values(selectedParticipants).filter(Boolean).length} 
            {" of "} {props.participants.length}
        </div>
        <div className='col-sm-5'>
            <input
              type="text"
              className="form-control"
              placeholder="Search participants..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>
      </div>

      <div className="item-list">
        {filteredParticipants.map((participant) => {
          let spit = participant.name.split('<br/>');
          
          return (
          <div key={participant.id} className="list-item">            
            <input
                id={`promote-participant-${participant.id}`}
              type="checkbox"
              checked={!!selectedParticipants[participant.id]}
              onChange={() => {
                setSelectedParticipants((prev) => ({
                  ...prev,
                  [participant.id]: !prev[participant.id],
                }));
              }}
            />
            <label htmlFor={`promote-participant-${participant.id}`}>{spit[0]}</label>
            {spit[1] && <div dangerouslySetInnerHTML={{__html:sanitizeHtml(spit[1])}}/>}
          </div>
        );
      })}
      </div>

      <div className="form-group">
        <div className="col-sm-offset-4 col-sm-8">
          <Button type="previous" onClick={props.Back} text="Previous" />
          <Button text="Save & Next" onClick={handleSaveAndNext} addClass="btn-primary" type='next'/>
        </div>
      </div>
    </div>
  );
};

export default ParticipantList;
